const initialState = {
    responsePaymentDetail: [],

    responsePaymentMethods: [],

};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "PAYMENT_DETAIL_RESPONSE":
            newState.responsePaymentDetail = action.value;
            break;
        case "PAYMENT_METHODS_RESPONSE":
            newState.responsePaymentMethods = action.value;
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;